import { getRaw } from "@/basedata";
import { CellFn } from "@/graphHandling/graphTypes";
import { backendRoutes } from "@/stores/utils/backendRoutes";

export const fetch_maaraystyypit: CellFn = async () => {
  try {
    return await getRaw("maaraystyypit", backendRoutes.maaraystyypit.path);
  } catch (err) {
    throw new Error(err as string);
  }
};
